import { Button } from "@chakra-ui/react";
import React, { useState } from "react";
import PopupWrapper from "./PopupWrapper";
import PublicViewRender from "../pages/project-showcase/admin/Presentation/PublicViewRender";

const TestViewButton = ({ data, type, disabled }) => {
  const [isPreview, setIsPreview] = useState(false);
  console.log({ data }, "TEST");
  return (
    <>
      <Button disabled={disabled} onClick={() => setIsPreview(true)}>
        Show Public View
      </Button>
      {isPreview && (
        <PopupWrapper
          // heading={"Test View"}
          width={"max-w-[97svw]"}
          maxHeight="max-h-[97dvh]"
          padding={1}
          bgColor={"bg-black/30"}
          onClose={() => setIsPreview(false)}
        >
          <div className="w-full overflow-hidden ">
            <PublicViewRender
              testName={data?.companyName}
              // isPreview={false}
              presentationType={type}
              testView={data}
              maxW={1350}
              isTestView={true}
            />
          </div>
        </PopupWrapper>
      )}
    </>
  );
};

export default TestViewButton;
